import React, { memo } from 'react'
import Avatar from '@material-ui/core/Avatar'
import Chip from '@material-ui/core/Chip'
import AddAlert from '@material-ui/icons/AddAlert'
import { capitalize } from '@material-ui/core'
import Button from '../../../components/sharedComponents/CustomButtons/Button'
import PolygonsTable from '../../../components/sharedComponents/Tablas/index'
import {
  permitsList,
  minPermisos,
  generalTitles,
} from '../../../constants/index'
import CardTitle from '../../../components/sharedComponents/CardTitle'
import Card from '../../../components/sharedComponents/Card/Card'
import CardHeader from '../../../components/sharedComponents/Card/CardHeader'
import CardBody from '../../../components/sharedComponents/Card/CardBody'
import Search from '../../../components/sharedComponents/SearchInput'
import Snackbar from '../../../components/sharedComponents/Snackbar/Snackbar'
import useStyles from './styles'
import canUseState from '../../../utils/canUseState'

const SegmentationPage4w = (props) => {
  const {
    pickup,
    update,
    loading,
    handleDelete,
    handleCreate,
    handleSearch,
    handleSelect,
    handleClick,
    search,
    selector,
    show,
    option,
    permits,
  } = props
  const classes = useStyles()

  const columns = [
    { title: 'Und', field: 'unidades', editable: 'never', hidden: true },
    { title: 'Marca', field: 'marca', editable: 'never' },
    { title: 'Linea', field: 'linea', editable: 'never' },
  ]

  return (
    <>
      <Snackbar
        place="tr" // Depende la dirección en la que se va a mostrar
        color="primary"
        icon={AddAlert}
        message={generalTitles.SEGMENT_WARNING}
        open={update}
      />
      <CardTitle
        title={generalTitles.TITLE_4W}
        subTitle="Segmente PickUp y Mobility"
      />
      <div
        className={classes.root}
        style={{ margin: '10px', alignContent: 'center' }}
      >
        <div>
          <Button color="warning" onClick={() => handleSelect('pickup')}>
            Pickup
          </Button>
          <Button onClick={() => handleSelect('mobility4w')} color="warning">
            Mobility
          </Button>
          {permits[permitsList.SEGMENTACION_4W] >= minPermisos.CREAR ? (
            <Button
              style={{ width: '100%' }}
              type="onClick"
              onClick={handleClick}
              color="warning"
            >
              Añadir Segmento
            </Button>
          ) : null}
        </div>
        {show && (
          <div>
            <Card>
              <CardHeader>
                <Search handleSearch={handleSearch} search={search} />
              </CardHeader>
              <CardBody className={classes.cardBody}>
                {selector &&
                  selector.map((item) => {
                    const color = canUseState(pickup, item, 'linea', 'LINEA')
                    return (
                      <div key={`${item.MARCA} - ${item.LINEA}`}>
                        <Chip
                          size="small"
                          avatar={<Avatar>{item.MARCA.charAt(0)}</Avatar>}
                          label={`${item.MARCA} - ${item.LINEA}`}
                          clickable
                          className={classes.chip}
                          color={!color ? 'primary' : 'default'}
                          onClick={handleCreate(item)}
                        />
                      </div>
                    )
                  })}
              </CardBody>
            </Card>
          </div>
        )}
      </div>
      <PolygonsTable
        columns={columns}
        dataTable={pickup}
        idPermisoTabla={permitsList.SEGMENTACION_4W}
        onDeleteTable={handleDelete}
        titleTable={`Segmento: ${capitalize(option || '')}`}
        hiddenEdit
        hiddenDelete={false}
        selectCheckbox={false}
        loading={loading}
      />
    </>
  )
}

export default memo(SegmentationPage4w)
